import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useTranslation } from "react-i18next";
import { SFDataGrid } from "@sf-core";
import StepContainer from "../stepContainer";
import StepRowContainer from "../components/stepRowCard";
import { API_PARAM } from "../../../constants/apiParams";
import { GRID_NAMES } from "../../../constants/gridNames";
import DetailsDialogs from "../components/detailsDialogs";
import { saveStep } from "../../../services/profileService";

const JobRoleSelectionPage = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [selectedJob, setSelectedJob] = useState(null);
  const [dialog, setDialog] = useState({ open: false });

  useEffect(() => {
    selectedJob ? props.setDisableNext(false) : props.setDisableNext(true);
  }, [selectedJob]);

  // Column definitions for the grid card component
  const columnDefs = [
    {
      field: "name",
      filter: true,
    },
    {
      field: "jobFamilyName",
      hide: true,
      selectedFilterColumn: true,
    },
  ];

  const onStepClose = async (goStepBack = false, stepCompleted = true) => {
    if (selectedJob) {
      let data = {
        currentStep: 0,
        isStepCompleted: stepCompleted,
        jobRoleId: selectedJob,
      };
      // Request to save the new user's Job Role and then navigate to next step or previous step
      await saveStep(data);
    }
    if (stepCompleted) {
      if (goStepBack) props.navigateStepBack();
      else props.navigateStepFront();
    }
  };

  useImperativeHandle(ref, () => ({
    onStepClose,
  }));

  const rowComponent = (nodeData) => {
    return (
      <StepRowContainer
        hasRadio
        hasHover
        rowId={nodeData.id}
        isSelected={selectedJob === nodeData.id}
        title={nodeData.name}
        description={nodeData.jobFamilyName}
        onInfoClicked={() => {
          setDialog({ open: true, jobId: nodeData.id });
        }}
        onSelect={(rowId) => {
          setSelectedJob(rowId);
        }}
      ></StepRowContainer>
    );
  };

  return (
    <>
      {dialog?.open && <DetailsDialogs dialog={dialog} setDialog={setDialog} />}
      <StepContainer
        stepTitle={t("profileScreen.jobSelectionStep.selection.header")}
        stepDescription={t(
          "profileScreen.jobSelectionStep.selection.description"
        )}
        onTransparentButtonClick={() => onStepClose(true)}
        transparentButtonLabel={t("profileScreen.btnBack")}
        onSecondaryButtonClick={onStepClose}
        secondaryButtonLabel={t("profileScreen.btnNext")}
        disableFrontButton={!selectedJob}
        hideScrollBar
      >
        <SFDataGrid
          gridName={GRID_NAMES.JOB_ROLES_SELECTION}
          searchLabel={t("profileScreen.drawer.searchJobsLabel")}
          filterLabel={t("profileScreen.drawer.searchJobsFilterLabel")}
          disableFilterSideBar
          columnDefs={columnDefs}
          persistState={true}
          hasRowSelection
          hideGrid={true}
          hideHeader
          {...(props.initialGridState && {
            initialGridState: props.initialGridState,
          })}
          datasourceUrl={API_PARAM.AVAILABLE_JOB_ROLES}
          filterValuesUrl={API_PARAM.AVAILABLE_JOB_VALUES}
          noCardBorder
          rowComponent={rowComponent}
        />
      </StepContainer>
    </>
  );
});

export default JobRoleSelectionPage;
